export default "__VITE_ASSET__CPDC2Ho0__"